import gql from 'graphql-tag';

export default gql`
  query buyer {
    buyer {
      name
      id
      telephone
      status
      imageUrl
      region
      isFreeshipOffer
      location {
        address
        ward
        district
        city
      }
      newMergedLocation {
        address
        ward
        district
        city
      }
      stores {
        id
        code
        name
        imageUrl
        telephone
        location {
          address
          ward
          district
          city
        }
        newMergedLocation {
          address
          ward
          district
          city
        }
        lastOrderedAt
        disabled
        status
        provinceId
        districtId
        wardId
        ward2507Id
        geoLat
        geoLon
        geoPlusCode
        internalId
        addressNote
        isForceUpdate
        redInvoice {
          companyName
          email
          mst
          address
          purchaserName
        }
        moq
      }
      redInvoiceInfo {
        companyName
        location {
          address
          district
          city
        }
        newMergedLocation {
          address
          ward
          district
          city
        }
        mst
        purchaserName
      }
      userGroups {
        name
        groupId
        permissions {
          action
        }
        members {
          email
          name
        }
      }
      enabledFeatures
      fullAddress {
        provinceCode
        districtCode
        wardCode
        provinceFullName
        districtFullName
        wardFullName
        kmrRegion
      }
      businessCategory
      businessType
      buyerType
      accountBuyerStatus
      refCode
    }
  }
`;
